module.exports = __webpack_public_path__ + "media/images/disbursement_channels/bank_account-d8908753d52469278435304d60dc3a17.svg";